import { lazy, Suspense } from 'react'

import type { PDFViewerProps } from './PDFViewer'

const LazyPDFViewer = lazy(() =>
    import('./PDFViewer').then((m) => ({ default: m.PDFViewer }))
)

export const PDFViewerLazy = (props: PDFViewerProps) => (
    <Suspense
        fallback={
            <div className="flex h-full items-center justify-center">
                <div className="h-8 w-8 animate-spin rounded-full border-2 border-background-primary border-t-transparent" />
            </div>
        }
    >
        <LazyPDFViewer {...props} />
    </Suspense>
)
